module.exports = __webpack_public_path__ + "static/media/dynamics-365.c5a3bd49.png";